import React from "react";
import { useMediaQuery } from '@mui/material'
import { HomeWrapper } from "./StyledComponent";
import Header from "./Header";
import Hero from "./Hero";
import Services from "./Services";
import AboutUs from "../NewTCP/AboutUs";
import AppInfo from "../NewTCP/AppInfo";
import FeedbackComplaint from "../NewTCP/FeedbackComplaint";
import LinksSlideshow from "../TCP-HP/LinksSlideShow";
import Footer from "../NewTCP/Footer";
import CitizenFacilitation from "./Facilation";
import Navbar from "../TCP-HP/Navbar";
import { useLocation } from "react-router-dom";

function NewTCPHome() {
    const location = useLocation();
	const homepath = location?.pathname?.includes("digit-ui/citizen")
    const isBigScreen = useMediaQuery(theme => theme.breakpoints.up('lg'))
    const isMediumScreen = useMediaQuery('(min-width: 900px) and (max-width: 1200px)')
    const isSmallScreen = useMediaQuery('(min-width: 600px) and (max-width: 899px)')
    return (
        <HomeWrapper style={{marginTop: homepath ? '-80px' : '0px'}}>
            <Header />
            <Navbar />
            <Hero />
            <Services />
            <AboutUs />
            <AppInfo />
            <CitizenFacilitation />
            <FeedbackComplaint />
            <LinksSlideshow
				titleStyles={{
					textTransform: 'uppercase',
					fontSize: '1.25rem',
					color: '#0E7693',
					fontWeight: 600,
				}}
				containerStyles={{ maxWidth: 1200 - 48, marginInline: 'auto' }}
				noOfSlides={isBigScreen ? 4 : isMediumScreen ? 3 : isSmallScreen ? 2 : 1}
			/>
            <Footer />
        </HomeWrapper>
    )
}

export default NewTCPHome